import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isTimeOffReadAccessForFacilitySelector = (communityId: number | null) =>
  createSelector(getUserPermissions, (permissions) => {
    if (!communityId) return false;
    if (permissions?.TIME_OFF?.access)
      return (
        permissions.TIME_OFF.access.includes('read') &&
        !!permissions.TIME_OFF.communities &&
        !!permissions.TIME_OFF.communities[communityId] &&
        !!permissions.TIME_OFF.communities[communityId].includes('read')
      );
    else return false;
  });
